import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { GroupsService } from 'core/services/groups.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export const GroupGameResolver: ResolveFn<any> = (
  route?: ActivatedRouteSnapshot,
  state?: RouterStateSnapshot,
  groupsService: GroupsService = inject(GroupsService)
): Observable<any> => {
  const group = route.parent.data.group;
  if (!group) return of(null);

  return groupsService.getGroupGame(group.id).pipe(
    map((res) => res),
    catchError((err) => of(null))
  );
};
